<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, CUSTOMER_TYPE, CUSTOMER_TYPES, PAYMENT_TYPE, PAYMENT_TYPES} from "../lib/constants";
    import {lastDateOfMonth} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import MultiSelectControl from "../components/controls/MultiSelectControl.svelte";

    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    export let departments;
    export let hotels;

    let search = {
        date_from: null,// '2024-01-01',
        date_to: null,// getDate('y-m-d'),
        department_id: '',
        hotel_id: [],
        customer_type: [CUSTOMER_TYPE.COMPANY],
        payment_type: [PAYMENT_TYPE.ON_ACCOUNT]
    }
    let departmentHotels = [];
    let paymentTypes = [];
    let customerTypes = [];
    let report = null;

    const initialize = () => {
        // init payment types
        Object.keys(PAYMENT_TYPE).map(key => {
            paymentTypes.push({
                id: PAYMENT_TYPE[key],
                name: PAYMENT_TYPES[PAYMENT_TYPE[key]],
                is_checked: search.payment_type.indexOf(PAYMENT_TYPE[key]) > -1 ? 1 : 0,
            });
        });

        // init customer types
        Object.keys(CUSTOMER_TYPE).map(key => {
            customerTypes.push({
                id: CUSTOMER_TYPE[key],
                name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]],
                is_checked: search.customer_type.indexOf(CUSTOMER_TYPE[key]) > -1 ? 1 : 0,
            });
        });
    }

    const validate = () => {
        if (!search.date_from || !search.date_to) {
            Notifier.showError("Select dates for the report!");
            return;
        }

        if (!search.department_id) {
            Notifier.showError("Select department for the report!");
            return;
        }

        if (!search.customer_type.length) {
            Notifier.showError("Select customer types for the report!");
            return;
        }

        if (!search.payment_type.length) {
            Notifier.showError("Select payment types for the report!");
            return;
        }

        return true;
    }


    const load = () => {
        const onSuccess = result => {
            report = result;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.department, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onDepartmentChange = () => {
        departmentHotels = [];
        search.hotel_id = [];

        let department = departments.find(x => x.id === search.department_id);
        department.hotels.map(hotelId => {
            let hotel = hotels.find(x => x.id == hotelId);
            if (hotel) {
                departmentHotels = [...departmentHotels, hotel];
            }
        });
    }

    const onOpenTransfer = id => {
        window.open(`/app/transfer/${id}`, "_blank");
    }

    const onExport = () => {
        if (!validate()) {
            return;
        }

        const extra = `?report=department&` + new URLSearchParams(search);
        window.open(API_URL + '/export.php' + extra);
    }

    initialize();
</script>

<PageHeader title="Department Report" controls={ pageHeaderControls } on:export={ onExport }/>

{#if departments}
    <div class="panel-simple p-2 mb-4">
        <div class="row">
            <div class="col-lg-1 col-sm-3 col-6">
                <DateControl bind:value="{ search.date_from }" placeholder="from" on:change={ onDateFromChange }/>
            </div>
            <div class="col-lg-1 col-sm-3 col-6 form-group-sm">
                <DateControl bind:value="{ search.date_to }" placeholder="to"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <select class="form-select" bind:value="{ search.department_id }" on:change={ onDepartmentChange }>
                    <option value="">department</option>
                    {#each departments as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ departmentHotels }" bind:value="{ search.hotel_id }"
                                    placeholder="hotel"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ customerTypes }" bind:value="{ search.customer_type }"
                                    placeholder="customer type"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ paymentTypes }" bind:value="{ search.payment_type }"
                                    placeholder="payment type"/>
            </div>
            <div class="col-xl-2 col-sm-3 col-12">
                <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
            </div>
        </div>
    </div>
{/if}

{#if report}
    <table class="table table-list table-list-border trans-account-hotels mb-5">
        <thead>
        <tr>
            <th colspan="11">
                Department: <b>{ report.department }</b><br>
                Period: <b>{ report.period }</b><br>
                Payment Type: <b>{ report.payment_type }</b><br>
                Customer Type: <b>{ report.customer_type }</b>
            </th>
        </tr>
        </thead>
        <tbody>
        {#if report.transfers.length}
            <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Commission</th>
                <th>Acc. Comm.</th>
                <th>Regent.</th>
                <th>Transf. Date</th>
                <th>Time</th>
                <th>Route</th>
                <th>Room</th>
                <th>Flight</th>
                <th>User</th>
            </tr>
            {#each report.transfers as transfer}
                <tr>
                    <td>
                        <span class="is-link" on:click={ () => onOpenTransfer(transfer.id) }>
                            { transfer.fullname }
                        </span>
                    </td>
                    <td>{ transfer.price }</td>
                    <td>{ transfer.department_price }</td>
                    <td>{ transfer.account_price }</td>
                    <td>{ transfer.company_price }</td>
                    <td>{ transfer.date }</td>
                    <td>{ transfer.time }</td>
                    <td>{ transfer.pickup_name } &#10140; { transfer.drop_name }</td>
                    <td>{ transfer.room_no }</td>
                    <td>{ transfer.flight_no }</td>
                    <td>{ transfer.user }</td>
                </tr>
            {/each}
            <tr>
                <td class="fw-bold">Sum</td>
                <td>{ report.total_price }</td>
                <td>{ report.total_department_price }</td>
                <td>{ report.total_account_price }</td>
                <td>{ report.total_company_price }</td>
                <td class="fw-bold">Net</td>
                <td>{ report.total_department_net }</td>
                <td class="fw-bold">Vat</td>
                <td>{ report.total_department_vat }</td>
                <td colspan="2"></td>
            </tr>
        {:else}
            <tr>
                <td colspan="11">Nothing found!</td>
            </tr>
        {/if}
        </tbody>
    </table>
{/if}